export const CLEAR_STORE = 'CLEAR_STORE';

export type ClearStoreAction = {
	type: typeof CLEAR_STORE;
};

export const clearStore = (): ClearStoreAction => ({
	type: CLEAR_STORE,
});

export type ActionType = ClearStoreAction;
